import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loadingStatus: "notLoading",
    usuario: {},
  },
  mutations: {
    SET_LOADING_STATUS(state, status) {
      state.loadingStatus = status;
    },
    SET_USUARIO(state, usuario) {
      state.usuario = usuario;
    },
  },
  actions: {
    fetchUsuario(context) {
      context.commit("SET_LOADING_STATUS", "loading");
      Vue.prototype.$api.get("/api/user").then((response) => {
        this.commit("SET_USUARIO", response.data);
      });
    },
  },
  getters: {
    usuario: (state) => {
      return state.usuario;
    },
  },
  modules: {},
});
